<script>
import Utility from '@/common/UtilityFunctions.js';
import VueSelect from '@/components/UI/VueSelect.vue';
import BaseMixin from '../BaseMixin.vue';
import ValidationError from '@/components/UI/ValidationError.vue';

export default {
  directives: {
    init: {
      bind(el, binding, vnode) {
        if (!vnode.context.localModel.initStep[binding.arg]) {
          vnode.context.value.Data.StudyInsuranceSubmitTemplate[binding.arg] = null;
          vnode.context.localModel.initStep[binding.arg] = true;
        }
      }
    }
  },
  components: { ValidationError, VueSelect },
  mixins: [BaseMixin],
  computed: {},
  mounted() {
    $(document).scrollTop(0);
    $('#additional-information').addClass('active');
  },
  methods: {
    showErrorModal(err) {
      this.$emit('showstderrormodal');
      if (err) {
        Utility.logError(err.message, this);
      }
    },
    showContactModal() {
      this.$emit('showstdcontactmodal');
    },
    showStopModal() {
      this.$emit('showstdstopmodal');
    }
  }
};
</script>
